import React from 'react';
import './Sidebar.css';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/Add';
import SidebarChannel from './SidebarChannel';
import SignalCellularAltIcon from '@material-ui/icons/SignalCellularAlt';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Avatar } from '@material-ui/core';
import MicIcon from '@material-ui/icons/Mic';
import HeadsetIcon from '@material-ui/icons/Headset';
import SettingsIcon from '@material-ui/icons/Settings';
import { useSelector } from 'react-redux';
import { selectUser } from './features/userSlice';
import db, { auth } from './firebase';
import { useState } from 'react';
import { useEffect } from 'react';
import firebase from "firebase";
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

const Sidebar = () => {
    const user = useSelector(selectUser)
    const [channels, setChannels] = useState([])


    useEffect(() => {
        db.collection('channels').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
            setChannels(snapshot.docs.map(doc => ({
                id: doc.id,
                channel: doc.data()
            })))
        })
    }, [])

    const handleAddChannel = (e) => {
        e.preventDefault()

        const channelName = prompt('Enter a new channel name')

        if (channelName) {
            db.collection('channels').add({
                channelName: channelName,
                timestamp: firebase.firestore.FieldValue.serverTimestamp()
            })

        }
    }

    return (
        <div className='sidebar' >
            <div className="sidebar__top">
                <img className="sidebar__logo" src="https://fontmeme.com/permalink/201015/c3f00aee45ecbe61bbeac697b8a4866b.png" alt="" />
                <ExitToAppIcon className="sidebar__logout" onClick={() => auth.signOut()} />
            </div>

            <div className="sidebar__channels">
                <div className="sidebar__channelsHeader">
                    <div className="sidebar__header">
                        <ExpandMoreIcon />
                        <h4>CHANNELS</h4>
                    </div>

                    <AddIcon fontSize="large" onClick={handleAddChannel} className='sidebar__addChannel' />
                </div>
            </div>
            <div className="sidebar__channelList">
                {
                    channels.map(({ id, channel }) => (
                        <SidebarChannel key={id} id={id} channelName={channel.channelName} />
                    ))
                }
            </div>

            <div className="sidebar__voice">
                <SignalCellularAltIcon className='sidebar__voiceIcons' fontSize='large' />
                <div className="sidebar__voiceInfo">
                    <h3>Server Connected</h3>
                    <p>{channels?.length} Channels are running.</p>
                </div>

                <div className="sidebar__voiceIcons">
                    <InfoOutlinedIcon />
                    <DeviceHubIcon />
                </div>
            </div>

            <div className="sidebar__profile">
                <Avatar src={user.photo} onClick={() => auth.signOut()} />
                <div className="sidebar__profileInfo" onClick={() => auth.signOut()}>
                    <h3>{user.displayName}</h3>
                    <p>Member #{user.uid.substring(0, 8)}</p>
                </div>

                <div className="sidebar__profileIcons">
                    <MicIcon />
                    <HeadsetIcon />
                    <SettingsIcon />
                </div>
            </div>
        </div>
    )
}

export default Sidebar
